import { PositionProps } from '@chakra-ui/react'
import { HTMLAttributes } from 'react'
import { DisplayProps, MarginProps } from 'styled-system'

import { TestIdProps } from 'designSystem/types/propTypes'

import { COLOR } from 'designSystem/foundations/constants/color'
import { SIZE } from 'designSystem/foundations/constants/size'

import PDSText from '../PDSText/PDSText'
import INTERNALxDiv from '../internal/elements/INTERNALxDiv'
import {
  INTERNAL_ComparisonHeaderRenderUnit,
  INTERNAL_ComparisonRenderUnit,
} from './INTERNAL_ComparisonTableTypes'

type BaseProps = HTMLAttributes<HTMLDivElement> &
  DisplayProps &
  MarginProps &
  PositionProps &
  TestIdProps

type Props = {
  rows: INTERNAL_ComparisonRenderUnit[]
  header: INTERNAL_ComparisonHeaderRenderUnit
} & BaseProps

export default function INTERNALxComparisonItem({
  header,
  rows,
  testId,
  ...props
}: Props) {
  const { label: headerLabel, render: HeaderComponent } = header

  return (
    <INTERNALxDiv
      borderRadius={SIZE.s8}
      flexGrow={1}
      minWidth="8rem"
      paddingY={SIZE.s8}
      {...props}
    >
      <INTERNALxDiv
        alignItems="center"
        borderBottom={`2px solid ${COLOR.content_border}`}
        display="flex"
        paddingBottom={SIZE.s8}
        paddingX={SIZE.s8}
        height="2rem"
        marginBottom={SIZE.s8}
        testId={testId && `${testId}-${headerLabel}-header`}
      >
        {HeaderComponent ? (
          <HeaderComponent />
        ) : (
          <PDSText color={header.color} size="md" weight="semibold">
            {headerLabel}
          </PDSText>
        )}
      </INTERNALxDiv>

      <INTERNALxDiv
        display="flex"
        flexDirection="column"
        gap={SIZE.s8}
        justifyContent="space-evenly"
      >
        {rows.map((row, i) => (
          <INTERNALxDiv
            key={`${row.label}-${i}`}
            display="flex"
            minHeight="2.5rem"
            padding={SIZE.s8}
            testId={testId && `${testId}-${row.label}-field`}
          >
            <PDSText size="md" weight="medium">
              {row.label}
            </PDSText>
          </INTERNALxDiv>
        ))}
      </INTERNALxDiv>
    </INTERNALxDiv>
  )
}
